import { render } from "./RightPanel.vue?vue&type=template&id=05f3b6be&scoped=true"
import script from "./RightPanel.vue?vue&type=script&lang=js"
export * from "./RightPanel.vue?vue&type=script&lang=js"

import "./RightPanel.vue?vue&type=style&index=0&id=05f3b6be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f3b6be"]])

export default __exports__